import { Document } from './../../../models/Document';
import { post } from './../../../api/index';
import {
  GET_DOWNLOAD_DOCUMENT,
  GET_DOWNLOAD_TICKET_PDF,
  GET_EXERCISE_RESIGN,
  GET_USER_DOCUMENT,
  GET_USER_PASSES_URL,
} from "./../../../api/apiRoutes";
import { useState } from "react";
import { GET_USER_SELECTS_URL } from "../../../api/apiRoutes";
import { useDispatch } from "react-redux";
import useFacility from "../../../../utils/hooks/useFacility";
import { Ticket } from "../../../models/Ticket";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import convertToPdf from "../../../../utils/convertToPdf";
import { setSuccessMessage } from "../../../store/alerts/alertsActions";

export default function useMethodAccount() {
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [passes, setPasses] = useState<Ticket[]>([]);
  const [docs, setDocs] = useState<Document[]>([]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState("");
  const { get } = useApiRequest();

  const getSelect = async () => {
    const { result, isError } = await get(GET_USER_SELECTS_URL(facilityIds));
    if (!isError) {
      setTickets(result);
    }
  };
  const getLimited = async () => {
    const { result, isError } = await get(GET_USER_PASSES_URL(facilityIds));
    if (!isError) {
      setPasses(result);
    }
  };

  const resignExercise = async (exerciseId: number) => {
    const exerciseIds = `0,${exerciseId}`;
    const { isError, errorTable } = await post(GET_EXERCISE_RESIGN(exerciseIds, facilityIds));
    if (!isError) {
      dispatch(setSuccessMessage("Zrezygnowałeś z tego terminu."));
      setTimeout(() => {
        getSelect();
        getLimited();
      }, 200);
    } else {
      setAlert(errorTable[0]);
      setTimeout(() => {
        setAlert("");
      }, 5000);
    }
  };

  const getUserDocuments = async () => {
    const { result, isError } = await get(GET_USER_DOCUMENT(facilityIds));
    if (!isError) {
      setDocs(result);
    }
  };

  const getBoughtTickets = async (documentIds: string) => {
    setLoading(true);
    const params = {
      facilityIds: `0,${facilityIds}`,
      documentIds: documentIds,
    };
    const { result, isError } = await get(GET_DOWNLOAD_TICKET_PDF(params));
    if (!isError) {
      const pdf = convertToPdf(result);
      window.open(URL.createObjectURL(pdf));
    }
    setLoading(false);
  };

  const getDownloadDocument = async (documentIds: string) => {
    setLoading(true);
    const params = {
      facilityIds: `0,${facilityIds}`,
      documentIds: documentIds,
    };
    const { result, isError } = await get(GET_DOWNLOAD_DOCUMENT(params));
    if (!isError) {
      const pdf = convertToPdf(result);
      window.open(URL.createObjectURL(pdf));
    }
    setLoading(false);
  };

  return {
    alert,
    getUserDocuments,
    getBoughtTickets,
    getDownloadDocument,
    resignExercise,
    getLimited,
    passes,
    getSelect,
    tickets,
    docs,
    loading,
  };
}
